import React, { useState, useEffect, useRef } from 'react';
import { Stack } from '@mui/material';
import './dataGrowth.scss';
import { getDecodedToken, getSector } from '../../service/service';
import AnalyticsVisualization from '../framework/analyticsVisualization';
import { dashboardUrl } from '../../service/config';

const prestoDataGrowth = () => {
	const userSector = getDecodedToken()?.sector?.name?.toLowerCase();
	const dataFetchedRef = useRef(false);
	const [sectorOptionsList, setSectorOptionsList] = useState<any[]>([]);
	const [checkedList, setCheckedList] = useState<any[]>([]);
	const [currSectorFilter, setCurrSectorFilter] = useState<any[]>([]);

	async function fetchSectorOptionsData() {
		const sectorRes = await getSector('1', '100', '');
		if (sectorRes.success) {
			setSectorOptionsList(sectorRes.data.sector.map((x: any) => x.name));
		}
	}
	useEffect(() => {
		if (dataFetchedRef.current) return;
		dataFetchedRef.current = true;

		if (userSector === 'all') fetchSectorOptionsData();
		let storedSectorFilter = localStorage.getItem('presto-summary-sector-filter')
			? JSON.parse(localStorage.getItem('presto-summary-sector-filter') ?? '')
			: null;
		if (storedSectorFilter) {
			setCheckedList(storedSectorFilter);
			setCurrSectorFilter(storedSectorFilter);
		}
	});
	return (

		<div className="presto-summary-panel">
			<Stack>
				<AnalyticsVisualization
					params={{
						dashboardUrl: dashboardUrl.prestoDataGrowthofQueries,
						className: 'prestoDataGrowthofQueriesContainer',
						otherParams: {
							'var-sector': currSectorFilter
						},
						seamless: true
					}}
				/>
			</Stack>
		</div>
	);
};

export default prestoDataGrowth;
